// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
require('../internals/export')({ target: 'Math', stat: true }, { RAD_PER_DEG: 180 / Math.PI });
